import React, { MouseEvent, useMemo, VFC } from 'react';
import { DataTable } from 'src/common/components/table/data-table';
import { generateColumn } from 'src/common/components/table/LegacyTable';
import { TooltipComponent } from 'src/common/tooltip/component';
import { DownloadStrongIcon } from 'src/monet/icons';
import { formatUnixTimestampSecondsToDate } from 'src/utils/date';
import { formatNumber } from 'src/utils/text';

export interface Invoice {
  id: string;
  amount_paid: number;
  invoice_pdf: string;
  period_start: number;
}

export interface DashboardSettingsBillingInvoiceListProps {
  invoices: Invoice[];
}

export const DashboardSettingsBillingInvoiceList: VFC<DashboardSettingsBillingInvoiceListProps> = ({ invoices }) => {
  const stopPropagation = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
  };

  const columns = useMemo(
    () => [
      generateColumn({
        Header: 'Date',
        accessor: 'period_start',
        width: 170,
        Cell: ({ index }: { index: number }) => (
          <span className='text-bedrock-p text-bedrock-black'>
            {formatUnixTimestampSecondsToDate(invoices[index].period_start)}
          </span>
        ),
      }),
      generateColumn({
        Header: 'Amount',
        accessor: 'amount_paid',
        width: 120,
        Cell: ({ index }: { index: number }) => (
          <span className='text-bedrock-p text-bedrock-black'>${formatNumber(invoices[index].amount_paid / 100)}</span>
        ),
      }),
      generateColumn({
        Header: '',
        accessor: 'actions',
        width: '100%',
        Cell: ({ index }: { index: number }) => (
          <div className='hidden group-hover:flex grow-0 items-center space-x-sm justify-end' onClick={stopPropagation}>
            <div className='flex items-center space-x-sm'>
              <TooltipComponent placement='top' tooltipContent='Download invoice'>
                <a className='shrink-0' href={invoices[index].invoice_pdf} download>
                  <DownloadStrongIcon />
                </a>
              </TooltipComponent>
            </div>
          </div>
        ),
      }),
    ],
    [invoices]
  );

  return (
    <div className='flex w-full mt-4'>
      <DataTable
        disableRowCursorPointer
        tableClassName='w-full'
        columns={columns}
        data={invoices}
        columnClasses={['break-words', 'break-words']}
      />
    </div>
  );
};
